export const LISTS_API_BASE_URL = '/api/list/v1/';
export const LISTS_API_BASE_URL_V2 = '/api/list/v2/';
export const LIST_ITEMS_SIZE = 50;
export const TAKE_ALL_LISTS = 2000;
export const LIST_SIZE = 50;
export const DEFAULT_SECURITY_LIST_KEY = 'application:security-list:default';
export const MAX_PEERS_IN_PRIMARY_LIST = 20;
